/*
 * For more context about the react-query defaults please see their
 * documentation: https://react-query.tanstack.com/guides/important-defaults
 */
export const QUERY_DEFAULT_OPTIONS = {
  queries: {
    retry: false, // no silently retrying queries right now
    staleTime: 30 * 60 * 1000, // 30 minutes stale time
    refetchOnWindowFocus: false, // no unscheduled refetchs
    cacheTime: 60 * 60 * 1000, // 60 minutes cache time
  },
};
